import { render } from "./vatInvoice.vue?vue&type=template&id=6adceb66&scoped=true"
import script from "./vatInvoice.vue?vue&type=script&lang=js"
export * from "./vatInvoice.vue?vue&type=script&lang=js"

import "./vatInvoice.vue?vue&type=style&index=0&id=6adceb66&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adceb66"]])

export default __exports__